import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="g7-access-hubs--batch-edit"
export default class extends Controller {
  connect() {
    this.ids = []
    this.dialogElement = document.querySelector('dialog#batchEdit')
    this.form = this.dialogElement.querySelector('form')

    this.element.addEventListener('click', (e) => {
      e.preventDefault();
      if(this.ids.length > 0) {
        this.dialogElement.showModal()
      } else {
        alert('Please select at least one row')
      }
    })

    document.querySelector('.datagrid').addEventListener('datagrids--table:selection-changed', (event) => {
      this.ids = event.detail.selectedRows
      this.form.querySelectorAll('input[type="hidden"][name="ids[]"]').forEach((field) => field.remove())
      this.ids.forEach((id) => this._addHiddenField(id))
    })

    this.locationSelect = this.dialogElement.querySelector('#location_id');
    this.cardModelsSelect = this.dialogElement.querySelector('#supported_card_model_ids');
    $(document).ready(() => {
      $(this.locationSelect).select2({width: '100%', placeholder: '<do not change>', dropdownParent: $('#batchEdit')})
      $(this.cardModelsSelect).select2({width: '100%', placeholder: '<do not change>', dropdownParent: $('#batchEdit')})
    })
  }

  _addHiddenField(id) {
    let field = document.createElement('input')
    field.setAttribute('type', 'hidden')
    field.setAttribute('name', 'ids[]')
    field.setAttribute('value', id)
    this.form.appendChild(field)
  }
}
